import { isObject } from 'radashi'

import * as next from '../types/next'

export const isBlockReference = (
  reference?: unknown
): reference is next.BlockReference => {
  return (
    isObject(reference) &&
    'referenceType' in reference &&
    reference.referenceType === next.REFERENCED_TYPE.BLOCK
  )
}

export const isContextParameterReference = (
  reference?: unknown
): reference is next.ContextParameterReference => {
  return (
    isObject(reference) &&
    'referenceType' in reference &&
    reference.referenceType === next.REFERENCED_TYPE.CONTEXT_PARAMETER
  )
}

export const isValidationRuleReference = (
  reference?: unknown
): reference is next.ValidationRuleReference => {
  return (
    isObject(reference) &&
    'referenceType' in reference &&
    reference.referenceType === next.REFERENCED_TYPE.VALIDATION_RULE
  )
}

export const isBlockFact = (fact?: unknown): fact is next.BlockFact => {
  return isBlockReference(fact) && fact.meaning === 'data source'
}

export const isContextParameterFact = (
  fact?: unknown
): fact is next.ContextParameterFact => {
  return isContextParameterReference(fact) && fact.meaning === 'data source'
}
